<div #toastOutlet></div>

<div class="flex flex-col lg:flex-row min-h-full lg:h-full w-full">
  <!-- left half -->
  <div
    class="sm:flex relative w-full lg:w-1/2 overflow-hidden text-white p-20 bg-primary hidden">
    <div
      class="absolute inset-0 animate-[spin_100s_linear_infinite] w-[200%] h-[200%] bg-[linear-gradient(to_bottom_left,_oklch(75%_0.08_270)_0%,_oklch(40%_0.12_255)_50%,_oklch(25%_0.14_250)_100%)]"></div>
    <div
      class="absolute animate-bounce floating-shape-2 top-0 -translate-y-2/3 left-2/5 w-192 h-192 opacity-60 bg-[radial-gradient(at_50%_55%,_oklch(98%_0.02_240)_0%,_oklch(65%_0.12_250)_45%,_oklch(30%_0.15_260)_90%)] rounded-full shadow-lg shadow-gray-700/40"></div>

    <div
      class="absolute animate-bounce floating-shape-2 top-4/6 -left-1/10 w-120 h-120 opacity-65 bg-[radial-gradient(at_50%_55%,_oklch(98%_0.02_240)_0%,_oklch(70%_0.12_250)_45%,_oklch(32%_0.16_265)_90%)] rounded-full shadow-xl shadow-gray-800/40"></div>

    <div
      class="absolute animate-bounce floating-shape-3 top-4/6 translate-y-2/5 -right-10 w-64 h-64 opacity-75 bg-[radial-gradient(at_50%_55%,_oklch(99%_0.015_240)_0%,_oklch(72%_0.13_250)_40%,_oklch(38%_0.18_265)_85%)] rounded-full shadow-lg shadow-gray-900/40"></div>

    <div
      class="absolute animate-bounce floating-shape-4 -top-5 -left-5 w-40 h-40 opacity-70 bg-[radial-gradient(at_50%_55%,_oklch(99%_0.01_240)_0%,_oklch(82%_0.12_250)_35%,_oklch(42%_0.15_265)_85%)] rounded-full shadow-lg shadow-gray-900/30"></div>


    <!-- เนื้อหา -->
    <div class="relative z-10 w-full lg:space-y-4 md:space-y-2">
      <div class="flex flex-row items-center space-x-1 lg:justify-start justify-center w-full">
        <img class="lg:size-20 2xl:size-30 size-25" src="/myrank_logo_no_text.png" alt="">
        <h1 class="text-7xl lg:text-7xl 2xl:text-8xl font-bold">
          MyRank</h1>
      </div>
      <div class="flex flex-col text-2xl lg:text-5xl/tight 2xl:text-6xl/tight font-semibold lg:items-start items-center justify-center w-full lg:justify-start">
        <p class="lg:hidden font-normal">Welcome to </p>
        <p class="lg:hidden font-normal">MyOrder Intelligence Co., Ltd.</p>
        <p class="lg:block hidden font-normal">Welcome to</p>
        <p class="hidden lg:block font-normal">MyOrder Intelligence</p>
        <p class="hidden lg:block font-normal">Co., Ltd.</p>
        <p class="md:pt-4 pt-2">Hiring Test</p>
      </div>
    </div>
</div>

  <!-- right half -->
  <div class="w-full lg:w-1/2 bg-white p-6 lg:p-12 lg:overflow-y-auto">
    <form
      (submit)="handleConfirmEmail($event)"
      (submit)="$event.preventDefault()">
      <h2 class="text-xl lg:text-2xl font-bold mb-6">
        <span
          ><u>Please</u> read the following instructions <u>carefully</u
          ><br />before you begin :</span
        >
      </h2>
      <ol
        class="list-decimal pl-4 lg:pl-6 space-y-3 lg:space-y-4 text-sm lg:text-base">
        <li class="pl-1">
          <b>Timed Questions: </b>Each question has its own time limit, which
          may vary depending on the complexity of the task.
        </li>
        <li class="pl-1">
          <b>Automatic Start: </b>The timer for each question will begin
          immediately once the question is opened.
        </li>
        <li class="pl-1">
          <b>Auto-Submission: </b>Once the time for a question runs out, your
          answer (if any) will be automatically submitted. You will not be able
          to make further changes.
        </li>
        <li class="pl-1">
          <b>Submit All: </b>You may review and modify your answers until you
          press the Submit All button on the test overview page, as long as the
          time for that question has not run out. (Please submit each question
          first!)
        </li>
        <li class="pl-1">
          <b>No Pausing: </b>The timer cannot be paused. Be sure you're ready
          before starting each question.
        </li>
        <li class="pl-1">
          <b>Best Effort: </b>Try to complete all questions within their time
          limits. Partial responses may still be considered.
        </li>
      </ol>

      <p class="mt-2 font-bold text-base lg:text-lg">
        Please ensure you're in a quiet environment with a stable internet
        connection before beginning.
      </p>

      <label class="mt-6 lg:mt-7 flex">
        <div class="inline-flex items-center">
          <label class="flex items-center cursor-pointer relative">
            <input
              defaultChecked
              type="checkbox"
              class="peer h-5 w-5 cursor-pointer appearance-none rounded-full shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
              id="check-custom-style"
              required />
            <span
              class="absolute text-white peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-3.5 w-3.5"
                viewBox="0 0 20 20"
                fill="currentColor"
                stroke="currentColor"
                stroke-width="1">
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"></path>
              </svg>
            </span>
          </label>
        </div>
        <p class="ml-2 font-semibold text-sm lg:text-base">
          I have read and understood the test instructions, and I am ready to
          begin the test.
        </p>
      </label>

      <div class="mt-4">
        <label for="" class="text-base lg:text-lg"
          >Please verify your e-mail</label
        >
        <input
          type="email"
          name="email"
          class="input w-full rounded px-3 py-2 mt-2 text-sm"
          placeholder="example@myorder.ai"
          required />
      </div>
      <div class="w-full h-10 mt-4">
        <app-button
          color="primary"
          size="medium"
          type="submit"
          label="START THE TEST"
          [disabled]="disabled()" />
      </div>
    </form>
    <div class="divider">OR</div>
    <button
      class="btn bg-white text-black border-[#e5e5e5] w-full rounded-lg flex items-center gap-2 p-2"
      [disabled]="disabled()"
      (click)="loginWithGithub()">
      <svg
        aria-label="GitHub logo"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor">
        <path
          fill-rule="evenodd"
          d="M8 0C3.58 0 0 3.58 0 8c0 3.54
      2.29 6.53 5.47 7.59.4.07.55-.17.55-.38
      0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52
      0-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87
      2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95
      0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12
      0 0 .67-.21 2.2.82a7.52 7.52 0 0 1 2-.27c.68 0 1.36.09
      2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08
      2.12.51.56.82 1.27.82 2.15 0 3.07-1.87
      3.75-3.65 3.95.29.25.54.73.54 1.48
      0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01
      8.01 0 0 0 16 8c0-4.42-3.58-8-8-8z"></path>
      </svg>
      Login with GitHub
    </button>
  </div>
</div>
